import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, switchMap, take } from 'rxjs';

import { ClientManagementActions } from './clients-managements.actions';
import * as ClientManagementSelectors from './clients-managements.selectors';

export const clientsManagementsResolver: ResolveFn<boolean> = (_r, _s) => {
  const store = inject(Store);

  return store.select(ClientManagementSelectors.selectChildClients).pipe(
    take(1),
    switchMap(clientList => {
      if (clientList.length < 2) {
        store.dispatch(ClientManagementActions.loadChildClients());
      }

      return of(true);
    }),
  );
};
